import { Loader2 } from 'lucide-react';

const AutoCloseOverlay = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-[16px] bg-white/80 backdrop-blur-sm">
      <Loader2 className="h-8 w-8 animate-spin text-point-500" />
      <div className="text-gr-700 Body3S15">곧 화면이 닫힙니다</div>
    </div>
  );
};

export default AutoCloseOverlay;
